import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import {Button, CardHeader, Grid, Paper, Tab, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

export class RWBInternalTeam extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            internalTeam: [],
            userInfo: {
                userId: '',
                name: '',
                headquarter_level: 0,
                extraUF: 0,
                uf: 0,
                targetUF: 0,
            },
            receiveUser:{
                userId: '',
            }
        };
    }

    componentDidMount() {
        this.getInternalTeam();
    }

    async getInternalTeam() {
        const url = `${Config.getInstance.apiUrl}/api/users/internal_team`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        this.setState({
            loading: true,
        });

        const response = await axios.get(url, {headers});

        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const data = response.data;
            const internalTeam = data.internalTeam;

            this.setState({
                internalTeam
            });
        } else {
            PopupMessage.error(`getInternalTeam Error: ${response.data.message}`)
        }
    }

    async getUserInfo() {
        const {userInfo} = this.state;

        const url = `${Config.getInstance.apiUrl}/api/users/user_info/${userInfo.userId}`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        this.setState({
            loading: true,
        });

        const response = await axios.get(url, {params: userInfo, headers});

        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const data = response.data;
            const user = data.user;

            if (!user) {
                PopupMessage.error(`getUserInfo Error: User not found`);
                return;
            }

            const userId = user.id;
            const name = user.name;
            const headquarter_level = user.headquarter_level;
            const extraUF = +user.extraUF || 0;
            const uf = +user.uf || 0;
            const targetUF = uf + extraUF;

            this.setState({
                userInfo: {
                    userId,
                    name,
                    headquarter_level,
                    extraUF,
                    uf,
                    targetUF
                },
                receiveUser: {
                    userId,
                }
            });
        } else {
            PopupMessage.error(`getUserInfo Error: ${response.data.message}`)
        }
    }

    async addInternalTeam() {
        const {userInfo} = this.state;

        if(userInfo.userId === '') {
            PopupMessage.error(`User ID is required`);
            return;
        }

        const url = `${Config.getInstance.apiUrl}/api/users/internal_team`;


        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        this.setState({
            loading: true,
        });

        const response = await axios.post(url, userInfo, {headers});

        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            PopupMessage.success(`Add Internal Team Success`);
            this.getInternalTeam();
        } else {
            PopupMessage.error(`getUserInfo Error: ${response.data.message}`)
        }
    }

    async updateInternalTeam() {
        const {userInfo} = this.state;
        if(userInfo.userId === '') {
            PopupMessage.error(`User ID is required`);
            return;
        }

        const url = `${Config.getInstance.apiUrl}/api/users/internal_team`;


        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        this.setState({
            loading: true,
        });

        const response = await axios.put(url, userInfo, {headers});

        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            PopupMessage.success(`Update Internal Team Success`);
            this.getInternalTeam();
        } else {
            PopupMessage.error(`getUserInfo Error: ${response.data.message}`)
        }
    }

    async deleteInternalTeam(userId: string) {
        // confirm popup
        const confirm = window.confirm(`Are you sure to remove this player?`);
        if (!confirm) {
            return;
        }

        const url = `${Config.getInstance.apiUrl}/api/users/internal_team/${userId}`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        this.setState({
            loading: true,
        });

        const response = await axios.delete(url, {headers});

        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            PopupMessage.success(`Delete Internal Team Success`);
            this.getInternalTeam();
        } else {
            PopupMessage.error(`getUserInfo Error: ${response.data.message}`)
        }
    }

    onChangeUserInfo(key: string, value: any) {
        const {userInfo} = this.state;
        userInfo[key] = value;

        // if key is userId, then reset name and headquarter_level
        if (key === 'userId') {
            userInfo.name = '';
            userInfo.headquarter_level = 0;
        }

        // if key is targetUF, then re-calculate extraUF
        if (key === 'targetUF') {
            const targetUF = +(value);

            if (Number.isNaN(targetUF)) {
                userInfo.targetUF = value;
            } else {
                const uf = userInfo.uf || 0;
                const extraUF = targetUF - uf;
    
                userInfo.extraUF = +extraUF.toFixed(2);
                userInfo.targetUF = value;
            }
        }

        this.setState({userInfo});
    }

    renderFilter() {
        const {userInfo, internalTeam, receiveUser} = this.state;

        const find = internalTeam.find((item: any) => item.userId === receiveUser.userId);

        const style = {
            // height: '100px',
            padding: '10px',
            width: '100%',
            // backgroundColor: "black",
        } as React.CSSProperties;

        const textStyle = {
            display: "flex",
            alignItems: "center",
        } as React.CSSProperties;


        return <Paper style={style}>
            <Grid container sm={12} rowSpacing={2}>
                <Grid item container sm={12}>
                    <Grid item sm={1} style={textStyle}>
                        <Typography >User ID:</Typography>
                    </Grid>
                    <Grid item sm={8}>
                        <TextField
                            fullWidth
                            value={userInfo.userId}
                            onChange={(e) => this.onChangeUserInfo('userId', e.target.value)}
                        />
                    </Grid>
                </Grid>
                <Grid item container sm={12}>
                    <Grid item sm={1} style={textStyle}>
                        <Typography >Name:</Typography>
                    </Grid>
                    <Grid item sm={5}>
                        <TextField
                            disabled
                            fullWidth
                            value={userInfo.name}
                            onChange={(e) => this.onChangeUserInfo('name', e.target.value)}
                        />
                    </Grid>
                </Grid>
                <Grid item container sm={12}>
                    <Grid item sm={1} style={textStyle}>
                        <Typography >HQ Level:</Typography>
                    </Grid>
                    <Grid item sm={5}>
                        <TextField
                            disabled
                            fullWidth
                            value={userInfo.headquarter_level}
                            onChange={(e) => this.onChangeUserInfo('headquarter_level', e.target.value)}
                        />
                    </Grid>
                </Grid>

                <Grid item container sm={12}>
                    <Grid item sm={1} style={textStyle}>
                        <Typography >Original UF:</Typography>
                    </Grid>
                    <Grid item sm={5}>
                        <TextField
                            disabled
                            fullWidth
                            value={userInfo.uf}
                            onChange={(e) => this.onChangeUserInfo('uf', e.target.value)}
                        />
                    </Grid>
                </Grid>

                <Grid item container sm={12}>
                    <Grid item sm={1} style={textStyle}>
                        <Typography >Extra UF:</Typography>
                    </Grid>
                    <Grid item sm={5}>
                        <TextField
                            fullWidth
                            value={userInfo.extraUF}
                            onChange={(e) => this.onChangeUserInfo('extraUF', e.target.value)}
                            type="number"
                            // disabled
                        />
                    </Grid>
                </Grid>

                {/* <Grid item container sm={12}>
                    <Grid item sm={1} style={textStyle}>
                        <Typography >Final UF:</Typography>
                    </Grid>
                    <Grid item sm={5}>
                        <TextField
                            fullWidth
                            value={userInfo.targetUF}
                            onChange={(e) => this.onChangeUserInfo('targetUF', e.target.value)}
                        />
                    </Grid>
                </Grid> */}

                <Grid item container sm={12} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.getUserInfo()}
                        >
                            Search
                        </Button>
                    </Grid>
                    <Grid item sm={1}>
                        {
                            !find ?
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.addInternalTeam()}
                                >
                                    Add
                                </Button>
                                :
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.updateInternalTeam()}
                                >
                                    Update
                                </Button>
                        }

                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    renderContent() {
        const {internalTeam} = this.state;
        return <Paper>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>UserId</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>HQ Level</TableCell>
                        <TableCell>Original UF</TableCell>
                        <TableCell>Extra UF</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {internalTeam.map((row: any) => (
                        row?.userId?.length > 0 ? <TableRow key={row.userId}>
                            <TableCell>{row.userId}</TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.headquarter_level}</TableCell>
                            <TableCell>{row.uf}</TableCell>
                            <TableCell>{row.extraUF || 0}</TableCell>
                            <TableCell>
                                <Button
                                    color="error"
                                    onClick={() => this.deleteInternalTeam(row.userId)}
                                >
                                    <CancelIcon />
                                </Button>
                            </TableCell>
                        </TableRow>
                        : null
                    ))}
                </TableBody>
            </Table>
        </Paper>
    }

    render() {
        return <Paper className="contentPadding">
            <CardHeader title="RWB Report" />
            {this.renderFilter()}
            <br />
            {this.renderContent()}
        </Paper>
    }
}